import React from "react";
import { motion } from "framer-motion";
import {
  MessageSquare,
  GitBranch,
  Gem,
  Zap,
  Cpu,
  Handshake,
} from "lucide-react";

const REASONS = [
  { icon: Zap, title: "Fast Doesn't Mean Rushed.", desc: "Premium quality. Delivered faster." },
  { icon: MessageSquare, title: "We Keep It Real.", desc: "No fake numbers. No fake promises." },
  { icon: GitBranch, title: "Built Around Results.", desc: "Every decision starts with one question — will this help your business grow?" },
  { icon: Cpu, title: "Future Ready.", desc: "Built using modern technology that scales with your business." },
  { icon: Handshake, title: "We're In It Together.", desc: "We don't disappear after launch. We stay. We improve. We grow." },
  { icon: Gem, title: "Premium By Default.", desc: "Craft and polish held to the standards of top tech brands." },
];

const WhyChoose = () => {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="relative py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 max-w-2xl lg:mb-20">
          <div className="mb-4 flex items-center gap-3">
            <div className="h-px w-8 bg-[var(--gold)]/60" />
            <span className="font-mono-label text-[var(--gold)]">
              06 · Why HR Enterprises
            </span>
          </div>
          <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Why clients<br />
            <span className="silver-gradient-text">choose HR.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, idx) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.6,
                delay: (idx % 3) * 0.08,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0e0e10] p-6 transition-all duration-500 hover:-translate-y-1 hover:border-[var(--gold)]/25 hover:bg-[#131316]"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12),transparent_60%)] opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
              <div className="grid h-11 w-11 place-items-center rounded-lg border border-white/10 bg-white/[0.03] text-[var(--gold-bright)]/85 transition-colors duration-500 group-hover:border-[var(--gold)]/40 group-hover:bg-[var(--gold)]/10">
                <r.icon className="h-5 w-5" strokeWidth={1.6} />
              </div>
              <h3 className="mt-5 font-display text-[17px] font-semibold tracking-tight text-white">
                {r.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-zinc-400">
                {r.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
